const Constants = {
    // url: 'http://127.0.0.1:8000/api/',
    url: 'https://corporate.careers4me.in/console/api/'
}

export default Constants